import React from "react";
import { graphql, useStaticQuery, Link } from "gatsby";
import { getLanguage } from "../helper/helper";
import PreviewCompatibleImage from "./PreviewCompatibleImage";

const OurTeam = () => {
  const locale = getLanguage();
  const { allMarkdownRemark } = useStaticQuery(
    graphql`
      query OurTeam($locale: String) {
        allMarkdownRemark(
          sort: { order: ASC, fields: [frontmatter___itemOrder] }
          filter: {
            frontmatter: {
              pageKey: { eq: "page_teampost" }
              locale: { eq: $locale }
            }
          }
        ) {
          edges {
            node {
              fields {
                slug
              }
              excerpt(pruneLength: 200)
              id
              frontmatter {
                name
                itemOrder
                description
                locale
                expertise
                image {
                  childImageSharp {
                    fluid(maxWidth: 300, quality: 100) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
        }
      }
    `
  );
  return allMarkdownRemark.edges
    .filter(({ node: post }) => post.frontmatter.locale === locale)
    .slice(0, 3)
    .map(({ node: post }) => (
      <Link
        key={post.fields.slug}
        to={`${post.fields.slug}`}
        title={post.frontmatter.title}
        className="column ourteam"
        style={{
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: "200px",
            marginBottom: "30px",
            display: "inline-block",
          }}
        >
          <PreviewCompatibleImage imageInfo={post.frontmatter} />
        </div>
        <h4>{post.frontmatter.name}</h4>
        <p>{post.frontmatter.expertise}</p>
      </Link>
    ));
};

export default OurTeam;
